import { EmployeeTabs } from "modules/EmployeeTab/EmployeeTab";
import { OfficeTabs } from "modules/OfficeTab/OfficeTabs";

export const getActiveEmployeeColumns = ({
  action,
  formatDate,
  history,
  userPermissions,
  setSelectedIndex,
  setShowFromReports,
}) => [
  {
    title: "Full Name",
    field: "fullname",
    render: (rowData) => {
      return (
        <button
          type="button"
          className="cursor-pointer"
          onClick={() => {
            const url = "/employeetab/employee";
            history.push({
              pathname: url,
              state: {
                employeeNumber: rowData?.employeeid,
                action,
              },
            });
            globalThis.location.reload();
            const userTabs = [...EmployeeTabs]
              .filter((tab) => userPermissions.includes(tab.permission))
              .map((tab) => ({ to: tab.to }));

            const index = userTabs.findIndex((c) => c.to === url);
            setSelectedIndex(index);
            setShowFromReports(true);
          }}
        >
          <span className="text-quinary font-bold underline text-sm">
            {rowData.fullname}
          </span>
        </button>
      );
    },
  },
  { title: "Employee ID", field: "employeenumber" },
  { title: "State", field: "state" },
  { title: "Local Office #", field: "storeNumber" },
  { title: "Department", field: "department" },
  { title: "Employee Type", field: "employeeTypeName" },
  {
    title: "Created Date",
    field: "createdDate",
    typeof: "date",
    dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
    render: (rowDetails) => (
      <div>
        <span>
          {rowDetails.createdDate ? formatDate(rowDetails.createdDate) : ""}
        </span>
      </div>
    ),
  },
  {
    title: "Hire Date",
    field: "hiredate",
    typeof: "date",
    dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
    render: (rowData) => (
      <div>{rowData.hiredate ? formatDate(rowData.hiredate) : ""}</div>
    ),
  },
  { title: "Employment Type", field: "employmenttype" },
  { title: "IQ Reports To", field: "reportsToFullname" },
  { title: "UltiPro Reports To", field: "ultiProReportsTo" },
  { title: "IQ Employee Status", field: "status" },
  { title: "UltiPro Employee Status", field: "ultiProEmployeeStatus" },
  { title: "IQ Job Title", field: "title" },
  { title: "UltiPro Job Title", field: "ultiProJobTitle" },
  {
    title: "IQ Office Location",
    field: "officeName",
    render: (rowData) => (
      <button
        type="button"
        className="cursor-pointer"
        onClick={() => {
          const url = "/officesettings/officesetting";
          history.push({
            pathname: url,
            state: {
              officeCode: rowData?.officecode,
              action,
            },
          });
          globalThis.location.reload();
          const userTabs = [...OfficeTabs]
            .filter((tab) => userPermissions.includes(tab.permission))
            .map((tab) => ({ to: tab.to }));

          const index = userTabs.findIndex((c) => c.to === url);
          setSelectedIndex(index);
        }}
      >
        <span className="text-quinary font-bold underline text-sm">
          {rowData.officeName}
        </span>
      </button>
    ),
  },
  { title: "UltiPro Office Location", field: "workLocation" },
  {
    title: "IQ Last Modified Date",
    field: "lastModifiedDate",
    typeof: "date",
    dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
    render: (rowData) => (
      <div>
        {rowData.lastModifiedDate ? formatDate(rowData.lastModifiedDate) : ""}
      </div>
    ),
  },
  {
    title: "UltiPro Last Modified Date",
    field: "ultiProLastModifiedDate",
    typeof: "date",
    dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
    render: (rowData) => (
      <div>
        {rowData.ultiProLastModifiedDate
          ? formatDate(rowData.ultiProLastModifiedDate)
          : ""}
      </div>
    ),
  },
];
